export default __webpack_public_path__ + "static/impact1-225031bef83292167b369065f889656a.png";